/**
 * Base64 without `atob`/`Buffer`: the demo store runs in browsers, Node and
 * Hermes, and only the first has both. Used to check a profile picture with
 * the server's rule before the demo keeps it.
 */
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const LOOKUP = new Map([...ALPHABET].map((c, i) => [c, i]));

/** Bytes of a base64 string, or null if it is not base64. */
export function base64ToBytes(b64: string): Uint8Array | null {
  const clean = b64.replace(/=+$/, '');
  if (!/^[A-Za-z0-9+/]*$/.test(clean) || clean.length % 4 === 1) return null;
  const out = new Uint8Array(Math.floor((clean.length * 3) / 4));
  let bits = 0;
  let value = 0;
  let o = 0;
  for (const c of clean) {
    value = (value << 6) | LOOKUP.get(c)!;
    bits += 6;
    if (bits >= 8) {
      bits -= 8;
      out[o++] = (value >> bits) & 0xff;
    }
  }
  return out;
}
